import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: match[1] });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.role === "admin" ? "/admin" : "/account");
      } catch { setError(true); }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
      {error ? (
        <div className="text-center">
          <p className="font-serif text-2xl text-pitch">Sign-in failed</p>
          <button onClick={() => navigate("/login")} className="mt-4 text-xs font-mono uppercase tracking-[0.2em] border-b border-pitch pb-1">Return to Sign In</button>
        </div>
      ) : (
        <div className="font-serif text-2xl tracking-[0.3em] text-stonemuted animate-pulse">SIGNING IN</div>
      )}
    </div>
  );
}
